import { Link } from 'react-router-dom';
import { ShieldCheck, FileText } from 'lucide-react';
import useSEO from '../hooks/useSEO';

const sections = [
  {
    number: '01',
    title: 'Éditeur du site',
    content: `Le site CyberGuard (https://cyber-guard.fr) est édité par :

Nom : Emma Gandolfi
Statut : Auto-entrepreneur
SIRET : 10235229100011
Siège social : La Côte-Saint-André, France
Email : contact@cyber-guard.fr`,
  },
  {
    number: '02',
    title: 'Hébergement',
    content: `Le site est hébergé par :

Vercel Inc.
440 N Barranca Ave #4133
Covina, CA 91723, États-Unis
https://vercel.com

Le backend est hébergé par :

Render Services, Inc.
525 Brannan St, Suite 300
San Francisco, CA 94107, États-Unis
https://render.com`,
  },
  {
    number: '03',
    title: 'Propriété intellectuelle',
    content: `L'ensemble des contenus présents sur le site CyberGuard (textes, images, logos, interface, algorithmes) sont la propriété exclusive d'Emma Gandolfi et sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.

Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable d'Emma Gandolfi.`,
  },
  {
    number: '04',
    title: 'Responsabilité',
    content: `CyberGuard s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, CyberGuard ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.

CyberGuard décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site, ainsi que pour tous dommages résultant d'une intrusion frauduleuse d'un tiers.`,
  },
  {
    number: '05',
    title: 'Liens hypertextes',
    content: `Le site CyberGuard peut contenir des liens vers d'autres sites internet. CyberGuard n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leurs pratiques en matière de confidentialité.`,
  },
  {
    number: '06',
    title: 'Droit applicable',
    content: `Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.

Pour toute question : contact@cyber-guard.fr`,
  },
];

export default function MentionsLegales() {
  useSEO('/mentions-legales');
  return (
    <div className="min-h-screen bg-[#09090b] text-white">

      {/* Header */}
      <header className="border-b border-zinc-800 bg-black/80 backdrop-blur sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <ShieldCheck className="w-7 h-7 text-blue-500" />
            <span className="font-mono text-lg font-black text-white uppercase tracking-tighter">CyberGuard</span>
          </Link>
          <Link to="/" className="text-zinc-500 hover:text-white font-mono text-xs uppercase tracking-widest transition-colors">
            ← Retour
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-16 space-y-12">

        {/* Titre */}
        <div className="text-center space-y-4">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-500/10 border border-blue-500/20">
            <FileText className="w-3 h-3 text-blue-400" />
            <span className="text-blue-400 text-[10px] font-mono uppercase tracking-widest">Informations légales</span>
          </div>
          <h1 className="text-4xl font-black font-mono uppercase tracking-tighter text-white">
            Mentions Légales
          </h1>
          <p className="text-zinc-500 font-mono text-xs">Conformément à la loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique</p>
        </div>

        {/* Sections */}
        <div className="space-y-6">
          {sections.map((section) => (
            <div key={section.number} className="bg-zinc-900/50 border border-zinc-800 rounded-sm p-6 space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-500/10 border border-blue-500/20 flex items-center justify-center rounded-sm shrink-0">
                  <span className="text-blue-400 font-mono text-[10px] font-black">{section.number}</span>
                </div>
                <h2 className="text-white font-mono font-bold text-sm uppercase tracking-widest">
                  {section.title}
                </h2>
              </div>
              <div className="pl-11">
                <p className="text-zinc-400 font-mono text-xs leading-relaxed whitespace-pre-line">
                  {section.content}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="border-t border-zinc-800 pt-8 flex items-center justify-between">
          <span className="text-zinc-600 font-mono text-[10px] uppercase">CyberGuard — Mentions Légales — 2025</span>
          <Link to="/" className="text-blue-500 hover:text-blue-400 font-mono text-xs uppercase transition-colors">
            Retour à l'accueil →
          </Link>
        </div>
      </main>
    </div>
  );
}
